






















import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { mdiCameraPlus } from '@mdi/js'
import MixinGeneral from '~/assets/mixins/general'
import ComponentIcon from '~/components/icon/icon.vue'

@Component({
  components: {
    ComponentIcon,
    ComponentPopup: () => import('~/components/popup/popup.vue'),
    ComponentImageUploadPhotoForm: () =>
      import('~/components/images/upload-photo-form.vue'),
  },
})
export default class ComponentImageUploadPhoto extends mixins(MixinGeneral) {
  @Prop({ type: Number, default: -1 }) readonly productId!: number

  private mdiCameraPlus = mdiCameraPlus
  private isPopup = false
}
